import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import htmlSerializer from '../../plugins/htmlSerializer'

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class GeneralSection extends Component {
  render() {
    let { 
      slice,
      linkResolver
    } = this.props
    const sp = slice.primary
    // console.log(slice)

    return (
      <section className="section-general">
        <div className="banner" style={{backgroundImage: `url(${sp.section_banner.url})`}}></div>
        <div className="container container-medium">
          {PrismicReact.RichText.render(sp.section_title)}
          {PrismicReact.RichText.render(sp.section_description, linkResolver, htmlSerializer)}
        </div>
      </section>
    )
  }
}

GeneralSection.propTypes = propTypes

export default GeneralSection


// WEBPACK FOOTER //
// ./src/components/GeneralPage/GeneralSection.js